import { Suspense, useState } from "react";
import { useToast } from "../../../../hooks/useToast";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Paper } from "@mui/material";
import { ImportTableForm } from "../components/importTableForm";
import { ResumenTableForm } from "../components/resumenTableForm";
import { ValidacionesTableForm } from "../components/validacionesTablaForm";
import { DatosTableForm } from "../components/datosTablaForm";
import { DividendosImportForm } from "../components/dividendosImportForm";
import { ImportTablaFormDto } from "../models/importTablaFormDto";
import UseTablaDesarrollo from "../hooks/useTablaDesarrollo";
import { TasaTablaForm } from "../models/tasaTablaForm";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { ModalErrorExcelMasivo } from "../../../endosos/endososPsm/components/modalErrorExcel";

export default function ImportTablaDesarrollo(){

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Maestros', url: `/maestros` },
        { label: 'Tablas de desarrollo', url: '/maestros/tabla-desarrollo' },
        { label: 'Importar', active: true },
    ];

    const { addToast } = useToast();
    const { resumen, validacion, datosTabla, dividendos, importarTabla, grabarTabla } = UseTablaDesarrollo();
    const navigate = useNavigate();

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const [ isSaveEnabled, setIsSaveEnabled ] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const [errorProcesamiento, setErrorProcesamiento] = useState<string>("")

    const onSubmitFile = async (e: ImportTablaFormDto) => {
        const result = await importarTabla(e);
        setIsSaveEnabled(result === "OK");
        if (result.includes("ERROR ARCHIVO")){
            setErrorProcesamiento(result);
            setShowError(true);
            return;
        }
        else if (result != "OK"){
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: result,
            });
        }
    }

    const schema = Yup.object<TasaTablaForm>().shape({
        tasa: Yup.number().required("Tasa requerida"),
        fechaEscrituracion: Yup.date().required("Fecha de escrituración requerida"),
        conDescuento: Yup.boolean().required("Campo requerido"),
        idReferencia: Yup.number().required("Id requerido")
    })

    const {
        control,
        formState: { errors, isDirty },
        reset,
        watch,
        handleSubmit,
        setValue
    } = useForm<TasaTablaForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    })

    const onSubmitImport = async (e: TasaTablaForm) =>{
        const isSumaAmortizacionNoUno = validacion.sumaAmortizacion !== 1;
        const isDiferenciaNoNula = validacion.diferenciasSuma !== 0;

        if (isSumaAmortizacionNoUno || isDiferenciaNoNula){
            const messageConfirmacion = (isSumaAmortizacionNoUno ? `La suma de amortización para la tabla de desarrollo importada es de ${validacion.sumaAmortizacion} ` : "") + 
                                        (isSumaAmortizacionNoUno && isDiferenciaNoNula ? "y la " : "") +
                                        (!isSumaAmortizacionNoUno && isDiferenciaNoNula ? "La " : "") +
                                        (isDiferenciaNoNula ? `diferencia del interés y capital con el monto cuota es de ${validacion.diferenciasSuma} ` : "") +
                                        "¿Desea continuar?"

            setModalConfirmacion({
                show: true,
                title: 'Confirmación',
                message: messageConfirmacion,
                metodo: () => {onSubmitImportConfirm(e)}
            });
            return;
        }
        
        onSubmitImportConfirm(e);
    }

    const onSubmitImportConfirm = async (e: TasaTablaForm) => {
        const response = await grabarTabla(e);
        if (response.status === 200 || response.status === 201){
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: response.data.message,
            });
            onCancel();
        } 
    }

    const onCancel = () => {
        navigate('/maestros/tabla-desarrollo');
    }
    
    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({ ...modalConfirmacion, show: false })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    title={modalConfirmacion.title}
                    show={modalConfirmacion.show}
                    message={modalConfirmacion.message}
                />
                <ModalErrorExcelMasivo 
                    onHide={() => {setShowError(false)}}
                    show={showError}
                    errores={errorProcesamiento}
                />
                <Paper elevation={3} sx={{ p: 3 }}>
                    <ImportTableForm onSubmit={onSubmitFile}/>
                    <ResumenTableForm resumen={resumen} isShowing={false}/>
                    <ValidacionesTableForm validacion={validacion}/>
                    <form onSubmit={handleSubmit(onSubmitImport)}>
                        <DatosTableForm datosTabla={datosTabla} control={control} 
                                    watch={watch} reset={reset} errors={errors} setValue={setValue}/>
                        <DividendosImportForm isSubmitEnabled={isSaveEnabled} dividendos={dividendos}
                                    onCancel={onCancel} isShowing={false}/>
                    </form>        
                </Paper>
            </Box>
        </Suspense>
    );
}